import type React from 'react';

import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

import SearchIcon from 'assets/icons/icn _ 16px _ Search.svg';
import TMXInput from 'components/inputs/TMXInput';
import { useStyles } from 'components/panels/avoidance/styles';
import { BodyLarge } from 'components/typography/Typography';
import { type GroupParticipantInterface } from 'typedefs/avoidance';

interface AvoidanceGroupsPanelProps {
  participants?: GroupParticipantInterface[];
  setParticipants: (participant: GroupParticipantInterface) => void;
  onChangeFilter: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
}

const AvoidanceGroupsPanel: React.FC<React.PropsWithChildren<AvoidanceGroupsPanelProps>> = ({
  participants,
  setParticipants,
  onChangeFilter,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <Grid container className={classes.panelWrapper} direction="column">
      <Grid item className={classes.filterPlayersWrapper}>
        <TMXInput
          fullWidth
          placeholder={t('searchPlayers')}
          startAdornment={
            <InputAdornment position="end">
              <Tooltip aria-label={t('search')} title={t('search')}>
                <IconButton className={classes.filterPlayersInputAdornment} size="large">
                  <img alt="search-icon" src={SearchIcon} />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          }
          onChange={onChangeFilter}
        />
      </Grid>
      <Grid item className={classes.listItemsContainer}>
        <Grid container direction="column">
          {participants?.map((participant) => (
            <Grid key={participant.id} item>
              <Grid container direction="row">
                <Grid item>
                  <Checkbox
                    checked={participant.checked}
                    color="primary"
                    onChange={() => setParticipants(participant)}
                  />
                </Grid>
                <Grid item className={classes.nameWrapper}>
                  <BodyLarge>{participant.name}</BodyLarge>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AvoidanceGroupsPanel;
